// Validates that a string is a same-origin relative path safe to use as a
// redirect target (server-side `Location` headers or client-side
// `router.push`). The leading `/` already prevents scheme-prefixed inputs
// (`javascript:`, `data:`, `https:`), so a colon later in the path or query
// is legal (e.g. `/foo?after=12:00`).
//
// Rejected:
//   - empty / oversized strings
//   - anything not starting with `/`
//   - protocol-relative (`//evil.com`) and the legacy backslash variant (`/\evil.com`)
//   - encoded equivalents that resolve to a protocol-relative form after
//     full decoding (`/%2F%2F…`, `/%252F%252F…`, etc.); closes a theoretical
//     bypass through intermediate URL normalization (CDN/proxy chains that
//     decode more than once)
const RETURN_PATH_MAX_LENGTH = 512
const DECODE_ITERATION_CAP = 8

// Single-pass decode misses double-encoded inputs; loop until stable.
function fullyDecode(s: string): string {
  let prev = s
  for (let i = 0; i < DECODE_ITERATION_CAP; i++) {
    const next = decodeURIComponent(prev)
    if (next === prev) return next
    prev = next
  }
  return prev
}

export function isSafeInternalPath(path: string): boolean {
  if (path.length === 0 || path.length > RETURN_PATH_MAX_LENGTH) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//') || path.startsWith('/\\')) return false

  let decoded: string
  try {
    decoded = fullyDecode(path)
  } catch {
    return false
  }
  if (decoded.startsWith('//') || decoded.startsWith('/\\')) return false

  return true
}
